import { HIERARCHY, HISTORY } from './specialFolderEnums';

export const DEFAULT_THREAD_VISIBILITY_FILTER = Object.freeze({
    includeThreadMessages: true,
    includeChatMessages: true,
    includeFolderChats: false
});

export const DEFAULT_SEARCH_THREAD_VISIBILITY_FILTER = DEFAULT_THREAD_VISIBILITY_FILTER;

export const DEFAULT_FOLDER_THREAD_VISIBILITY_FILTER = Object.freeze({
    includeThreadMessages: false,
    includeChatMessages: false,
    includeFolderChats: false
});

export const normalizeThreadVisibilityFilter = (
    value,
    defaults = DEFAULT_SEARCH_THREAD_VISIBILITY_FILTER
) => {
    const normalizedDefaults = {
        includeThreadMessages: defaults?.includeThreadMessages !== false,
        includeChatMessages: defaults?.includeChatMessages !== false,
        includeFolderChats: defaults?.includeFolderChats === true
    };

    return {
        includeThreadMessages:
            value?.includeThreadMessages == null
                ? normalizedDefaults.includeThreadMessages
                : value.includeThreadMessages !== false,
        includeChatMessages:
            value?.includeChatMessages == null
                ? normalizedDefaults.includeChatMessages
                : value.includeChatMessages !== false,
        includeFolderChats:
            value?.includeFolderChats == null
                ? normalizedDefaults.includeFolderChats
                : value.includeFolderChats === true
    };
};

export const hasModifiedThreadVisibilityFilter = (
    value,
    defaults = DEFAULT_SEARCH_THREAD_VISIBILITY_FILTER
) => {
    const normalized = normalizeThreadVisibilityFilter(value, defaults);
    const normalizedDefaults = normalizeThreadVisibilityFilter(defaults, defaults);

    return (
        normalized.includeThreadMessages !== normalizedDefaults.includeThreadMessages ||
        normalized.includeChatMessages !== normalizedDefaults.includeChatMessages ||
        normalized.includeFolderChats !== normalizedDefaults.includeFolderChats
    );
};

export const buildThreadVisibilityFilterInput = (
    value,
    defaults = DEFAULT_SEARCH_THREAD_VISIBILITY_FILTER
) => {
    const normalized = normalizeThreadVisibilityFilter(value, defaults);

    return {
        includeThreadMessages: normalized.includeThreadMessages,
        includeChatMessages: normalized.includeChatMessages,
        includeFolderChats: normalized.includeFolderChats
    };
};

export const usesDerivedThreadVisibilityFilter = folder => {
    const folderId = folder?.id;
    return folderId === HISTORY || folderId === HIERARCHY;
};
